import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { statusUpdate as statusUpdateAPI} from 'services/apiOrders';

const useUpdateStatus = () => {
  
    const queryClient = useQueryClient();
    const{isPending: isUpdating, isSuccess: isUpdated, mutate: updateStatus} = useMutation({
        mutationFn: statusUpdateAPI,
        onSuccess:(data)=>{
            queryClient.setQueryData(["updatedStatus"],data),
            queryClient.invalidateQueries({queryKey:["orderList"]})
            queryClient.invalidateQueries({queryKey:["dashStatus"]})
            toast.success("Status Updated")
        },
        onError:(error)=>{
            console.log("Error occurred while updating orders",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
        }

    })

    return{isUpdating, isUpdated, updateStatus}
}

export default useUpdateStatus